import { createIcon } from '@chakra-ui/react';

export const WhiteEyeIcon = createIcon({
  displayName: 'WhiteEyeIcon',
  viewBox: '0 0 26 24',
  path: [
    <path
      key="1"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 12.9773C4.49409 9.18591 8.18182 6.5 12.5 6.5C16.8182 6.5 20.5059 9.18591 22 12.9773C20.5059 16.7686 16.8182 19.4545 12.5 19.4545C8.18182 19.4545 4.49409 16.7686 3 12.9773ZM20.1175 12.9772C18.6925 10.0668 15.7734 8.22723 12.5002 8.22723C9.22701 8.22723 6.30791 10.0668 4.88291 12.9772C6.30791 15.8877 9.21837 17.7272 12.5002 17.7272C15.782 17.7272 18.6925 15.8877 20.1175 12.9772ZM12.5 10.8182C13.6918 10.8182 14.6591 11.7855 14.6591 12.9773C14.6591 14.1691 13.6918 15.1364 12.5 15.1364C11.3082 15.1364 10.3409 14.1691 10.3409 12.9773C10.3409 11.7855 11.3082 10.8182 12.5 10.8182ZM8.61357 12.9773C8.61357 10.8354 10.3581 9.09089 12.4999 9.09089C14.6417 9.09089 16.3863 10.8354 16.3863 12.9773C16.3863 15.1191 14.6417 16.8636 12.4999 16.8636C10.3581 16.8636 8.61357 15.1191 8.61357 12.9773Z"
      fill="#ffffff"
    />
  ]
});
